module.exports = __webpack_public_path__ + "static/adm_text-69bb0aa0a8464352f336eb7320deb09b.jpg";